// document.addEventListener('DOMContentLoaded', function () {
(function(){
    let configuration = []
    let productIdArr = ""
    let textFileshunt = "";
    let customizedWaiImgUrl = document.querySelector(".customized-wai-img");
    let firstImgSrc = "";

    //图片切换功能
    function changeImg(type) {
        switch (type) {
            case "Black,Sun":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Black_Photochromic.png?v=1750140224";
                break;
            case "Black,Photochromic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Black_Photochromic.png?v=1750140224";
                break;
            case "Black,Classic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Black_Classic.png?v=1750140222";
                break;
            case "Gradient,Sun":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Gradient_Photochromic.png?v=1750140226";
                break;
            case "Gradient,Photochromic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Gradient_Photochromic.png?v=1750140226";
                break;
            case "Gradient,Classic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Gradient_Classic.png?v=1750140226";
                break;
            case "Tortoise,Sun":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Tortoise_Photochromic.png?v=1750140226";
                break;
            case "Tortoise,Photochromic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Tortoise_Photochromic.png?v=1750140226";
                break;
            case "Tortoise,Classic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Tortoise_Classic.png?v=1750140226";
                break;
            case "Black,Sun,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Black_Photochromic.png?v=1750140224";
                break;
            case "Black,Photochromic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Black_Photochromic_Grey.png?v=1750140224";
                break;
            case "Black,Classic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/g3.png";
                break;
            case "Gradient,Sun,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Gradient_Photochromic.png?v=1750140226";
                break;
            case "Gradient,Photochromic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Gradient_Photochromic_Grey.png?v=1750140226";
                break;
            case "Gradient,Classic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/g6.png";
                break;
            case "Tortoise,Sun,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Tortoise_Photochromic.png?v=1750140226";
                break;
            case "Tortoise,Photochromic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/Tortoise_Photochromic_Grey.png?v=1750140226";
                break;
            case "Tortoise,Classic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/g9.png";
                break;
            case "Black,Photochromic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/c1.png?v=1749471099";
                break;
            case "Black,Classic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/c2.png?v=1749471099";
                break;
            case "Gradient,Photochromic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/c3.png?v=1749471099";
                break;
            case "Gradient,Classic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/c4.png?v=1749471099";
                break;
            case "Tortoise,Photochromic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/c5.png?v=1749471099";
                break;
            case "Tortoise,Classic":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/c6.png?v=1749471099";
                break;
            case "Black,Photochromic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/bpg1.png?v=1749471555";
                break;
            case "Black,Classic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/bpg2.png?v=1749471555";
                break;
            case "Gradient,Photochromic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/bpg3.png?v=1749471555";
                break;
            case "Gradient,Classic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/bpg4.png?v=1749471555";
                break;
            case "Tortoise,Photochromic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/bpg5.png?v=1749471555";
                break;
            case "Tortoise,Classic,Grey":
                customizedWaiImgUrl.src = "https://cdn.shopify.com/s/files/1/0885/7557/4317/files/bpg6.png?v=1749471555";
                break;
            default:
                break;
        }
    }
    //主页弹窗功能
    //关闭按钮
    let customizedX = document.querySelectorAll('.progress-bar-box-svg-close');
    let customizedInformationPopUp = document.querySelector('.customized-information-pop-up');
    let customizedWaiImg = document.querySelector('.customized-wai-img');
    const customizedBtn = document.querySelector('[halli-customize-lenses]');
    const sizeSpans = document.querySelectorAll('.ring-size-content span');
    // let selectedSize = 'Measure it later';
    customizedBtn.classList.remove('active');
    // document.querySelector(".ring-size-content span:nth-child(9) .ring-size-content-svg-position-path1").style.fill = "#ffffff";
    // document.querySelector(".ring-size-content span:nth-child(9) .ring-size-content-svg-position-g").style.fill = "#004137";
    // document.querySelector(".ring-tipe-mb").style.opacity = "0.6";
    sizeSpans.forEach(span => {
        span.addEventListener('click', function() {
            sizeSpans.forEach(s => s.classList.remove('active'));
            this.classList.add('active');
            // selectedSize = this.textContent;
            customizedBtn.classList.add('active');

            // 更改配件ID值
            const selectedValue = this.getAttribute("data-id");
            const accessoriesWrapperEle = this.closest(".accessories-wrapper");
            const accessoriesProduct = accessoriesWrapperEle.querySelector("[name^='accessories-product']");
            accessoriesProduct.value = selectedValue;
            // if(this == document.querySelector(".ring-size-content span:nth-child(9)")){
            //     document.querySelector(".ring-size-content span:nth-child(9) .ring-size-content-svg-position-path1").style.fill = "#ffffff";
            //     document.querySelector(".ring-size-content span:nth-child(9) .ring-size-content-svg-position-g").style.fill = "#004137";
            //     document.querySelector(".ring-tipe-mb").style.opacity = "0.6";
            // }else{
            //     document.querySelector(".ring-tipe-mb").style.opacity = "0";
            // }
        });
    });
    let originalPrice = 0
    const originalShowCustomized = showCustomizedInformation;
    //弹窗功能
    customizedBtn.addEventListener('click', function(e) {
        const scrollTop = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollTop}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100vw';
        let priceStr = document.querySelector("div.price__sale > span.price-item.price-item--sale.price-item--last").innerText;
        let cleanedStr = priceStr.replace('$', '').replace('USD', '').trim();
        let numericValue = parseFloat(cleanedStr.replace(/,/g, ''));
        originalPrice = numericValue;
        let formattedValue = numericValue.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        document.querySelector(".customized-price-number").innerText = formattedValue;
        document.querySelector(".customized-price-number").setAttribute("data-price", formattedValue);
        document.querySelectorAll(".progress-bar-box-mb-price-number").forEach(item => {
            item.innerText = formattedValue;
            item.setAttribute("data-price", formattedValue);
        });
        originalShowCustomized(); 
    });
    let confirmShutdown = document.querySelector('.confirm_shutdown');
    customizedX.forEach(item => {
        item.addEventListener('click', function () {
            confirmShutdown.style.display = 'block'; 
        })
    })
    //取消按钮
    let confirmShutdownCancel = document.querySelector('.confirm_shutdown_btn_cancel');
    confirmShutdownCancel.addEventListener('click', function () {
        document.querySelector('body').style.overflow = 'auto';
        confirmShutdown.style.display = 'none';
        hideCustomizedInformation()
        window.location.href = 'https://hallidayglobal.com/products/halliday-glasses';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollTop);
    })
    let confirmShutdownConfirm = document.querySelector('.confirm_shutdown_btn_confirm');
    confirmShutdownConfirm.addEventListener('click', function () {
        confirmShutdown.style.display = 'none';
    })
    // 数据处理功能
    function showCustomizedInformation() {
        let colorItem = configuration.find(item => item.hasOwnProperty("Frame Color"));
        let sizeItem = configuration.find(item => item.hasOwnProperty("Ring Size"));
        let productId = configuration.find(item => item.hasOwnProperty("primaryproductId"));
        const selectedColor = document.querySelector(".product-form__input--pill input[type=radio]:checked+label")?.innerText;
        if (selectedColor) {
            if (colorItem) {
                colorItem["Frame Color"] = selectedColor; 
            } else {
                configuration.push({ "Frame Color": selectedColor });
            }
        }
        // if (selectedSize) {
        //     if (sizeItem) {
        //         sizeItem["Ring Size"] = selectedSize;
        //     } else {
        //         configuration.push({ "Ring Size": selectedSize });
        //     }
        // }
        const primaryProductId = document.querySelector(".installment > input[type=hidden]:nth-child(3)")?.value;
        productIdArr = primaryProductId;
        customizedInformationPopUp.style.display = 'block';
        customizedInformationPopUp.style.transition = 'none';
        customizedInformationPopUp.style.opacity = '0';
        customizedInformationPopUp.style.transform = 'translate(-50%,70%) scale(0.6)';
        void customizedInformationPopUp.offsetWidth;
        customizedInformationPopUp.style.transition = 'transform 0.8s cubic-bezier(0.7, 0, 0.2, 1), opacity 0.8s cubic-bezier(0.7, 0, 0.2, 1)';
        customizedInformationPopUp.style.opacity = '1';
        customizedInformationPopUp.style.transform = 'translate(-50%, 0) scale(1)';
        requestAnimationFrame(() => {
            customizedInformationPopUp.addEventListener('transitionend', function handler() {
                customizedInformationPopUp.removeEventListener('transitionend', handler);
            });  
        });
        let customizedWaiImgUrl = document.querySelector(".product__media > img").src;
        firstImgSrc = customizedWaiImgUrl;  
        customizedWaiImg.src = customizedWaiImgUrl;  
    }
    // 隐藏弹窗功能
    function hideCustomizedInformation() {
        customizedInformationPopUp.style.transition = 'transform 0.8s cubic-bezier(0.7, 0, 0.2, 1), opacity 0.8s cubic-bezier(0.7, 0, 0.2, 1)';
        customizedInformationPopUp.style.opacity = '0';
        customizedInformationPopUp.style.transform = 'translate(-50%,70%) scale(0.6)';
        customizedInformationPopUp.addEventListener('transitionend', function handler() {
            customizedInformationPopUp.style.display = 'none';
            customizedInformationPopUp.removeEventListener('transitionend', handler);
        });
    }
    let showNoneAllDom = document.querySelectorAll('.showNone');
    function showNoneAll() {
        showNoneAllDom.forEach(item => {
            item.classList.add('display_active_none');
        }); 
    }
    let lens_btn = document.querySelectorAll('.lens_btn');
    lens_btn.forEach(item => {
        item.addEventListener('click', function () {
            let text = item.querySelector('.title')?.textContent.trim();
            if (text) {
                let existingConfig = configuration.find(config => config["Specify your lenses"]);
                if (existingConfig) {
                    existingConfig["Prescription need"] = text;
                }else{
                    configuration.push({
                        "Prescription need":text
                    })
                }
                showNone(text);
            } else {
                console.warn('未找到 span');
            }
        });
    });
    let typesOfPrescriptionLensesBtn = document.querySelectorAll('.types_of_prescription_lenses_btn');
    typesOfPrescriptionLensesBtn.forEach(item => {
        item.addEventListener('click', function () {
            let text = item.querySelector('.title')?.textContent.trim();
            if (text) {
                let existingConfig = configuration.find(config => config["Prescription type"]);
                if (existingConfig) {
                    existingConfig["Prescription type"] = text;
                }else{
                    configuration.push({
                        "Prescription type":text
                    })
                }
                showNone(text);
            } else {
                console.warn('未找到 span');
            }
        });
    });
    let chooseHowToEnterPrescriptionsBtn = document.querySelectorAll('.choose_how_to_enter_prescriptions_btn');
    chooseHowToEnterPrescriptionsBtn.forEach(item => {
        item.addEventListener('click', function () {
            chooseHowToEnterPrescriptionsBtn.forEach(sibling => sibling.classList.remove('active'));
            item.classList.add('active');
            let text = item.querySelector('.title')?.textContent.trim();
            if (text) {
                let existingConfig = configuration.find(config => config["Prescription"]);
                if (existingConfig) {
                    existingConfig["Prescription"] = text;
                }else{
                    configuration.push({
                        "Prescription":text
                    })
                }
                showNone(text);
            } else {
            }
        });
    });

    //add和onadd走向
    let enterPrescriptionBtn = document.querySelector('.enter_prescription_affirm_btn');
    const affirmCheckbox = document.querySelector('.enter_prescription_affirm_check_input');
    const errorMessage = document.querySelector('.error-message-container');
    enterPrescriptionBtn.addEventListener('click', function () {
        let text = enterPrescriptionBtn.textContent.trim();
            if (addForm == "add") {
                const addOdText = document.querySelector(".add-od-text").innerText.trim();
                const addOsText = document.querySelector(".add-os-text").innerText.trim();
                function isNumber(val) {
                    return !isNaN(val) && val !== '' && val !== null;
                }
                if (isNumber(addOdText) || isNumber(addOsText)) {
                    if(prescriptionData.cylinder.os == 'None' || prescriptionData.cylinder.os == '0.00'){
                    }else if(prescriptionData.axis.os == "None"){ 
                        document.querySelector('.axis-error-text').style.display = 'block';
                        setTimeout(() => {
                            document.querySelector('.axis-error-text').style.display = 'none';
                        }, 3000);
                        return;
                    }
                    if(prescriptionData.cylinder.od == 'None' || prescriptionData.cylinder.od == '0.00'){
                    }else if(prescriptionData.axis.od == "None"){
                        document.querySelector('.axis-error-text').style.display = 'block';
                        setTimeout(() => {
                            document.querySelector('.axis-error-text').style.display = 'none';
                        }, 3000);
                        return;
                    }
                    if (!affirmCheckbox.checked) {
                        document.querySelector('.enter_prescription_affirm_container').style.display = 'block';
                        setTimeout(() => {
                            document.querySelector('.enter_prescription_affirm_container').style.display = 'none';
                        }, 3000);
                        return;
                    } 
                    showNone(addForm); 
                } else {
                    errorMessage.style.display = 'block';
                    setTimeout(() => {
                        errorMessage.style.display = 'none';
                    }, 3000);
                    return;
                }
            } else if (addForm == "noadd") {
                if(prescriptionData.cylinder.os == 'None' || prescriptionData.cylinder.os == '0.00'){
                }else if(prescriptionData.axis.os == "None"){
                    document.querySelector('.axis-error-text').style.display = 'block';
                    setTimeout(() => {
                        document.querySelector('.axis-error-text').style.display = 'none';
                    }, 3000);
                    return;
                }
                if(prescriptionData.cylinder.od == 'None' || prescriptionData.cylinder.od == '0.00'){
                }else if(prescriptionData.axis.od == "None"){
                    document.querySelector('.axis-error-text').style.display = 'block';
                    setTimeout(() => {
                        document.querySelector('.axis-error-text').style.display = 'none';
                    }, 3000);
                    return;
                }
                if (!affirmCheckbox.checked) {
                    document.querySelector('.enter_prescription_affirm_container').style.display = 'block';
                    setTimeout(() => {
                        document.querySelector('.enter_prescription_affirm_container').style.display = 'none';
                    }, 3000);
                    return;
                } 
                showNone(addForm);
            } else {
            }

            if (enterPrescription) {
                prescriptionData = { ...prescriptionData, ...prescriptionDataDistance };
            } else {
                prescriptionData = { ...prescriptionData, ...prescriptionDataDistanceTwo };
            }
            let existingPrescriptionData = configuration.find(config => config["prescriptionData"]);
            if (existingPrescriptionData) {
                existingPrescriptionData["prescriptionData"] = prescriptionData;
            } else {
                configuration.push({ "prescriptionData": prescriptionData });
            }
            if (addForm == "noadd") {
                const prescriptionObj = configuration.find(item => item.prescriptionData);
                if (prescriptionObj && prescriptionObj.prescriptionData && prescriptionObj.prescriptionData.add) {
                    delete prescriptionObj.prescriptionData.add;
                }
            }
        });
    let uploadFileFormBtn = document.querySelector('.upload_file_form_affirm_btn');
    const affirmCheckboxFile = document.querySelector('.upload_file_form_affirm_check_input');
    uploadFileFormBtn.addEventListener('click', function () {
            let text = "fileUploadForm";
            if (text) {
                if(prescriptionDataDistanceFile.file){ 
                }else{
                    document.querySelector('.upload_file_form_affirm_container_from_file_error').style.display = 'block';
                    setTimeout(() => {
                        document.querySelector('.upload_file_form_affirm_container_from_file_error').style.display = 'none';
                    }, 3000);
                    return;
                }
                if (!affirmCheckboxFile.checked) {
                    document.querySelector('.upload_file_form_affirm_container_from_file').style.display = 'block';
                    setTimeout(() => {
                        document.querySelector('.upload_file_form_affirm_container_from_file').style.display = 'none';
                    }, 3000);
                    return;
                }
                showNone(text);

            } else {
                console.warn('未找到 span');
            }
            if (yourPrescription) {
                configuration = [...configuration, { "prescriptionDataFile": prescriptionDataDistanceFile }];
            } else {
                configuration = [...configuration, { "prescriptionDataFile": prescriptionDataDistanceTwoFile }];
            }
    });
    let typesOfNoPrescriptionLensesBtn = document.querySelectorAll('.types_of_no_prescription_lenses_btn');
    let typesOfNoPrescriptionLensesNextStepBtnText = ""
    typesOfNoPrescriptionLensesBtn.forEach(item => {
        item.addEventListener('click', function () {
            typesOfNoPrescriptionLensesBtn.forEach(sibling => sibling.classList.remove('active'));
            item.classList.add('active');
            typesOfNoPrescriptionLensesNextStepBtnText = item.querySelector('.title')?.textContent.trim();
            if (typesOfNoPrescriptionLensesNextStepBtnText) {
                let existingConfig = configuration.find(config => config["Lens type"]);
                if (existingConfig) {
                    existingConfig["Lens type"] = typesOfNoPrescriptionLensesNextStepBtnText;
                }else{ 
                    configuration.push({ 
                        "Lens type":typesOfNoPrescriptionLensesNextStepBtnText
                    }) 
                }
                let FrameColor = configuration.find(config => config["Frame Color"]);
                let LensType = configuration.find(config => config["Lens type"]);
                let color = FrameColor["Frame Color"];
                let lensType = LensType["Lens type"];
                changeImg(`${color},${lensType}`);
            } else {
                console.warn('未找到 span');
            }
        });
    });
    let typesOfNoPrescriptionLensesNextStepBtn = document.querySelector('.types_of_no_prescription_lenses_next_step_btn');
    typesOfNoPrescriptionLensesNextStepBtn.addEventListener('click', function () {
        if(document.querySelector(".hover_btn.active")){
            showNone(typesOfNoPrescriptionLensesNextStepBtnText);
            deleteActive(); 
        }else{
            document.querySelector('.types_of_no_prescription_lenses_want').style.display = 'block';
            setTimeout(() => {
                document.querySelector('.types_of_no_prescription_lenses_want').style.display = 'none';
            }, 3000);
        }
    });
    let selectLensColor1Btn = document.querySelectorAll('.select_lens_color1_btn');
    let selectLensColor1NextStepBtnText = "selectLensColor1NextStepBtnText"
    selectLensColor1Btn.forEach(item => {
        item.addEventListener('click', function () {
            selectLensColor1Btn.forEach(sibling => sibling.classList.remove('active'));
            item.classList.add('active');
            let selectLensColor = item.querySelector('.title')?.textContent.trim(); 
            if (selectLensColor1NextStepBtnText) {
                let existingConfig = configuration.find(config => config["Lens color"]);
                if (existingConfig) {
                    existingConfig["Lens color"] = selectLensColor;
                }else{
                    configuration.push({
                        "Lens color":selectLensColor
                    })
                } 
                let FrameColor = configuration.find(config => config["Frame Color"]);
                let LensType = configuration.find(config => config["Lens type"]);
                let LensColor = configuration.find(config => config["Lens color"]);
                let color = FrameColor["Frame Color"];
                let lensType = LensType["Lens type"];
                let lensColor = LensColor["Lens color"];
                changeImg(`${color},${lensType},${lensColor}`);
            } else { 
                console.warn('未找到 span');
            }
        });
    });
    let selectLensColor1NextStepBtn = document.querySelector('.select_lens_color1_next_step_btn');
    selectLensColor1NextStepBtn.addEventListener('click', function () {
        if(document.querySelector(".hover_btn.active")){
            showNone(selectLensColor1NextStepBtnText);
        }else{
            document.querySelector('.select_lens_color1_want').style.display = 'block';
            setTimeout(() => {
                document.querySelector('.select_lens_color1_want').style.display = 'none';
            }, 3000);
        }
    });
    let selectLensColor2Btn = document.querySelectorAll('.select_lens_color2_btn');
    let selectLensColor2NextStepBtnText = "selectLensColor2NextStepBtnText"
    selectLensColor2Btn.forEach(item => {
        item.addEventListener('click', function () {
            selectLensColor2Btn.forEach(sibling => sibling.classList.remove('active'));
            item.classList.add('active');
            let selectLensColor = item.querySelector('.title')?.textContent.trim();
            if (selectLensColor2NextStepBtnText) {
                let existingConfig = configuration.find(config => config["Lens color"]);
                if (existingConfig) {
                    existingConfig["Lens color"] = selectLensColor;
                }else{
                    configuration.push({
                        "Lens color":selectLensColor
                    })
                }
                let FrameColor = configuration.find(config => config["Frame Color"]);
                let LensType = configuration.find(config => config["Lens type"]);
                let LensColor = configuration.find(config => config["Lens color"]);
                let color = FrameColor["Frame Color"];
                let lensType = LensType["Lens type"];
                let lensColor = LensColor["Lens color"];
                changeImg(`${color},${lensType},${lensColor}`);
            } else {
                console.warn('未找到 span');
            }
        });
    });
    let selectLensColor2NextStepBtn = document.querySelector('.select_lens_color2_next_step_btn');
    selectLensColor2NextStepBtn.addEventListener('click', function () {
        if(document.querySelector(".hover_btn.active")){
            showNone(selectLensColor2NextStepBtnText);
        }else{
            document.querySelector('.select_lens_color2_want').style.display = 'block';
            setTimeout(() => {
                document.querySelector('.select_lens_color2_want').style.display = 'none';
            }, 3000);
        }
    });
    let priceTan = document.querySelectorAll(".customized-information-num-price-number");
    let chooseYourLensThicknessBtn = document.querySelectorAll('.choose_your_lens_thickness_btn');
    let chooseYourLensThicknessBtnNextStepBtnText = "chooseYourLensThicknessBtn"
    chooseYourLensThicknessBtn.forEach((item,index) => {
        item.addEventListener('click', function () {
            chooseYourLensThicknessBtn.forEach(sibling => sibling.classList.remove('active'));
            item.classList.add('active');
            let chooseYourLensText = item.querySelector('.customized-information-num-text')?.textContent.trim();
            let price = originalPrice + Number(priceTan[index].innerText);
            let formattedValue = price.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            document.querySelector(".customized-price-number").innerText = formattedValue;
            document.querySelector(".customized-price-number").setAttribute("data-price", formattedValue);
            document.querySelectorAll(".progress-bar-box-mb-price-number").forEach(item => {
                item.innerText = formattedValue;
                item.setAttribute("data-price", formattedValue);
            }); 

            if (chooseYourLensThicknessBtnNextStepBtnText) {
                let existingConfig = configuration.find(config => config["Lens thickness"]);
                if (existingConfig) {
                    existingConfig["Lens thickness"] = chooseYourLensText;
                }else{
                    configuration.push({
                        "Lens thickness":chooseYourLensText
                    })
                }
            } else {
                console.warn('未找到 span');
            }  
        });
    });
    function chooseYourLensThickness(start, end) {
        chooseYourLensThicknessBtn.forEach((item, idx) => {
            if (idx >= start && idx <= end) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });
    }
    let chooseYourLensThicknessNextStepBtn = document.querySelector('.choose_your_lens_thickness_next_step');
    chooseYourLensThicknessNextStepBtn.addEventListener('click', function () {
        if(document.querySelector(".choose_your_lens_thickness_btn.active")){
            showNone(chooseYourLensThicknessBtnNextStepBtnText);
        }else{
            document.querySelector('.choose_your_lens_thickness_want').style.display = 'block';
            setTimeout(() => {
                document.querySelector('.choose_your_lens_thickness_want').style.display = 'none';
            }, 3000);
        }
    });
    let chooseYourLensTypeBtn = document.querySelectorAll('.choose_your_lens_type_btn');
    chooseYourLensTypeBtn.forEach(item => {
        item.addEventListener('click', function () {
            chooseYourLensTypeBtn.forEach(sibling => sibling.classList.remove('active'));
            let twoTitle = item.getAttribute('two-title');
            let twoTitleText = item.querySelector('.title')?.textContent.trim();
            if (twoTitle) {
                let existingConfig = configuration.find(config => config["Prescription lens type"]);
                if (existingConfig) {
                    existingConfig["Prescription lens type"] = twoTitleText;
                }else{
                    configuration.push({
                        "Prescription lens type":twoTitleText
                    })
                }
                let FrameColor = configuration.find(config => config["Frame Color"]);
                let PrescriptionLenseType = configuration.find(config => config["Prescription lens type"]);
                let color = FrameColor["Frame Color"];
                let PrescriptionLenseTypeValue = PrescriptionLenseType["Prescription lens type"];
                changeImg(`${color},${PrescriptionLenseTypeValue}`);
                showNone(twoTitle);
            } else {
                console.warn('未找到 span');
            }
        });
    });
    let selectLensColor3Btn = document.querySelectorAll('.select_lens_color3_btn');
    let selectLensColor3NextStepBtnText = "selectLensColor3NextStepBtnText"
    selectLensColor3Btn.forEach(item => {
        item.addEventListener('click', function () {
            selectLensColor3Btn.forEach(sibling => sibling.classList.remove('active'));
            item.classList.add('active');
            let selectLensColor3 = item.querySelector('.title')?.textContent.trim();
            if (selectLensColor3) {
                let existingConfig = configuration.find(config => config["Lens color"]);
                if (existingConfig) {
                    existingConfig["Lens color"] = selectLensColor3;
                }else{
                    configuration.push({
                        "Lens color":selectLensColor3
                    })
                }
                let FrameColor = configuration.find(config => config["Frame Color"]);
                let PrescriptionLenseType = configuration.find(config => config["Prescription lens type"]);
                let LensColor = configuration.find(config => config["Lens color"]);
                let color = FrameColor["Frame Color"];  
                let PrescriptionLenseTypeValue = PrescriptionLenseType["Prescription lens type"];
                let lensColor = LensColor["Lens color"]; 
                changeImg(`${color},${PrescriptionLenseTypeValue},${lensColor}`);
            } else {
                console.warn('未找到 span');
            }
        });
    });
    let selectLensColor3NextStepBtn = document.querySelector('.select_lens_color3_next_step_btn');
    selectLensColor3NextStepBtn.addEventListener('click', function () {
        if(document.querySelector(".hover_btn.active")){
            showNone(selectLensColor3NextStepBtnText);
        }else{
            document.querySelector('.select_lens_color3_want').style.display = 'block';
            setTimeout(() => {
                document.querySelector('.select_lens_color3_want').style.display = 'none';
            }, 3000);
        }
    });
    let stepHistory = ['lens_solution_customization'];
    let addForm = ""
    function showNone(text) {
        setTimeout(() => {
            if(window.innerWidth >= 749){
                if (document.querySelector('.review_your_selections').classList.contains('display_active_none')) {
                    document.querySelector(".customized-wai-product-information-add-to-cart-btn").style.display = 'none';
                } else {  
                    document.querySelector(".customized-wai-product-information-price").style.textAlign = 'left';
                    document.querySelector(".customized-wai-product-information-add-to-cart-btn").style.display = 'flex';
                }
            }  
        }, 0);
        fromPopUpBtnBack.removeAttribute('disabled');
        fromPopUpBtnBack.style.opacity = '1';
        fromPopUpBtnBack.style.cursor = 'pointer';
        switch (text) {
            case 'Non-Prescription':
                showNoneAll();
                document.querySelector('.types_of_no_prescription_lenses')?.classList.remove('display_active_none');
                stepHistory.push('types_of_no_prescription_lenses');
                break; 
            case 'Prescription':
                showNoneAll();
                document.querySelector('.types_of_prescription_lenses')?.classList.remove('display_active_none');   
                stepHistory.push('types_of_prescription_lenses');
                break;
            case 'Single-vision':
                showNoneAll();
                addForm = "noadd"
                textFileshunt = "Single-vision";
                document.querySelector('.choose_how_to_enter_prescriptions')?.classList.remove('display_active_none');
                stepHistory.push('choose_how_to_enter_prescriptions');
                break; 
            case 'Enter it manually':
                showNoneAll();
                if (addForm == "add") {
                    prescriptionData.add = { os: 'None', od: 'None' };
                    document.querySelector(".enter_prescription_table > table > tbody > tr:nth-child(4)").style.display = 'contents';
                }else{
                    document.querySelector(".enter_prescription_table > table > tbody > tr:nth-child(4)").style.display = 'none';
                }
                document.querySelector('.enter_prescription')?.classList.remove('display_active_none');
                stepHistory.push('enter_prescription');
                break;
            case 'noadd':
                showNoneAll();
                document.querySelector('.choose_your_lens_type')?.classList.remove('display_active_none');
                stepHistory.push('choose_your_lens_type');
                break;    
            case 'add':
                showNoneAll();
                document.querySelector('.choose_your_lens_thickness')?.classList.remove('display_active_none');
                stepHistory.push('choose_your_lens_thickness');
                break;   
            case 'Sun':
                showNoneAll();
                document.querySelector('.select_lens_color1')?.classList.remove('display_active_none');
                stepHistory.push('select_lens_color1');
                break;
            case 'Photochromic':
                showNoneAll();
                document.querySelector('.select_lens_color2')?.classList.remove('display_active_none');
                stepHistory.push('select_lens_color2');
                break;
            case 'selectLensColor1NextStepBtnText':
                showNoneAll();
                const reviewSection = document.querySelector('.review_your_selections');
                reviewSection?.classList.remove('display_active_none');
                stepHistory.push('review_your_selections');  
                renderConfiguration(reviewSection, true);
                break; 
            case 'selectLensColor2NextStepBtnText':
                showNoneAll();
                const chooseYourLensThicknessSection = document.querySelector('.review_your_selections');
                chooseYourLensThicknessSection?.classList.remove('display_active_none');
                stepHistory.push('review_your_selections');
                renderConfiguration(chooseYourLensThicknessSection, true);
                break;
            case 'fileUploadForm':
                showNoneAll();
                if (textFileshunt == "Single-vision") {
                    document.querySelector('.choose_your_lens_type')?.classList.remove('display_active_none');
                    stepHistory.push('choose_your_lens_type');
                }else{
                    document.querySelector('.choose_your_lens_thickness')?.classList.remove('display_active_none');
                    stepHistory.push('choose_your_lens_thickness'); 
                }
                break;
            case 'chooseYourLensThicknessBtn':
                showNoneAll();
                const reviewSection2 = document.querySelector('.review_your_selections');
                reviewSection2?.classList.remove('display_active_none');
                stepHistory.push('review_your_selections');  
                renderConfiguration(reviewSection2, true);
                break;
            case 'Classic':
                showNoneAll();
                const reviewSection3 = document.querySelector('.review_your_selections');
                reviewSection3?.classList.remove('display_active_none');
                stepHistory.push('review_your_selections'); 
                renderConfiguration(reviewSection3, true);
                break;
            case 'Progressive':
                showNoneAll();
                addForm = "add"
                textFileshunt = "Progressive";
                chooseYourLensThickness(6,8)
                document.querySelector('.choose_how_to_enter_prescriptions')?.classList.remove('display_active_none');
                stepHistory.push('choose_how_to_enter_prescriptions');
                break;
            case 'Upload it now':
                showNoneAll();
                document.querySelector('.upload_file_form')?.classList.remove('display_active_none');
                stepHistory.push('upload_file_form');
                break; 
            case 'Send it later':
                showNoneAll();
                if (addForm == "add") {
                    document.querySelector(".choose_your_lens_thickness")?.classList.remove('display_active_none');
                    stepHistory.push('choose_your_lens_thickness');
                }else{
                    document.querySelector('.choose_your_lens_type')?.classList.remove('display_active_none');
                    stepHistory.push('choose_your_lens_type');
                }
                break;   
            case 'Photochromictwo':
                showNoneAll();
                document.querySelector('.select_lens_color3')?.classList.remove('display_active_none');
                stepHistory.push('select_lens_color3');
                chooseYourLensThickness(0,2)
                break;
            case 'selectLensColor3NextStepBtnText':
                showNoneAll();
                document.querySelector('.choose_your_lens_thickness')?.classList.remove('display_active_none');
                stepHistory.push('choose_your_lens_thickness');
                break;
            case 'Cleartwo':
                showNoneAll();
                document.querySelector('.choose_your_lens_thickness')?.classList.remove('display_active_none');
                stepHistory.push('choose_your_lens_thickness');
                chooseYourLensThickness(3,5)
                break;
        }
    } 
    function deleteActive() {
        let active = document.querySelectorAll('.hover_btn');
        active.forEach(item => {
            item.classList.remove('active');
        });
    }
    // 渲染配置功能
    function renderConfiguration(container, reviewSection) {
        let dataContainer = container.querySelector('.customized-information-pop-up-content');

        // 
        if(reviewSection) {
            dataContainer = container.querySelector('.customized-review-data');
            const accessoriesContainer = container.querySelector('.customized-accessories-choose');
            const customizedAccessoriesProduct = accessoriesContainer.querySelector("input");
            const customizedSizePicker = accessoriesContainer.querySelector(".ring-size-picker");

            if(!accessoriesContainer.classList.contains('customized-accessories-choose--sold-out')) {
                // 判断外层配件是否选中
                const pageAccessoriesProduct = document.getElementById("accessories-product-page");
                if(pageAccessoriesProduct.checked) {
                    customizedAccessoriesProduct.checked = true;
                    customizedAccessoriesProduct.value = pageAccessoriesProduct.value;
                    customizedSizePicker.style.display = "block";
                    customizedSizePicker.querySelectorAll(".ring-size-content span").forEach(item => {
                        if(item.getAttribute("data-id") == pageAccessoriesProduct.value) {
                            item.classList.add("active");
                        } else {
                            item.classList.remove("active");
                        }
                    });
                    
                    // 重置价格
                    const curTotalPrice = parseFloat(document.querySelector(".customized-price-number").getAttribute("data-price")) * 100;
                    const customizedAccessoriesProductPrice = parseInt(customizedAccessoriesProduct.getAttribute("data-price"));
                    document.querySelector(".customized-price-number").innerHTML = halliCurrency(curTotalPrice + customizedAccessoriesProductPrice, "{{amount}}");
                    console.log(document.querySelector(".progress-bar-box-mb-price-number"))
                    document.querySelector(".review_your_selections .progress-bar-box-mb-price-number").innerHTML = halliCurrency(curTotalPrice + customizedAccessoriesProductPrice, "{{amount}}");
                } else {
                    customizedAccessoriesProduct.checked = false;
                    customizedSizePicker.style.display = "none";
                    customizedSizePicker.querySelectorAll(".ring-size-content span").forEach((item, index) => {
                        if(index === 0) {
                            item.classList.add("active");
                        } else {
                            item.classList.remove("active");
                        }
                    });
                    // 重置价格
                    const curTotalPrice = parseFloat(document.querySelector(".customized-price-number").getAttribute("data-price")) * 100;
                    document.querySelector(".customized-price-number").innerHTML = halliCurrency(curTotalPrice, "{{amount}}");
                    document.querySelector(".review_your_selections .progress-bar-box-mb-price-number").innerHTML = halliCurrency(curTotalPrice, "{{amount}}");
                }
            }
        }; 
        dataContainer.innerHTML = '';
        let html = '<div class="review-data">';
        configuration.forEach(config => {
            const key = Object.keys(config)[0];
            const value = config[key];
            if (key === "prescriptionData") {
                html += `
                    <div class="review-item" style="display: flex;flex-direction: column;">
                        <div class="review-label">${key}:</div>
                        <div class="review-value">
                            ${renderPrescriptionTable(value)}
                        </div>
                    </div>
                `;
            } else if (typeof value === 'object' && value !== null) {
                const nestedHtml = formatNestedObject(value);
                if (nestedHtml) {
                    html += `
                        <div class="review-item">
                            <div class="review-label">${key}:</div>
                            <div class="review-value">
                                ${nestedHtml}
                            </div>
                        </div>
                    `;
                }
            } else {
                html += `
                    <div class="review-item">
                        <div class="review-label">${key}:</div>
                        <div class="review-value">${value}</div>
                    </div>
                `;
            }
        });
        html += '</div>';
        dataContainer.innerHTML = html;
    }
    // 渲染处方表功能
    function renderPrescriptionTable(data) {
        let html = `
            <table class="prescription-table" border="1" cellspacing="0" cellpadding="5">
                <thead>
                    <tr>
                        <th>Category</th>
                        <th>OS (Left Eye)</th>
                        <th>OD (Right Eye)</th>
                    </tr>
                </thead>
                <tbody>
        `;
        for (const key in data) {
            if (key === "add" && data[key].od === "--" && data[key].os === "--") continue;
            if (key === "PD") {
                const leftPD = data[key]?.os !== undefined ? data[key].os : null;
                const rightPD = data[key]?.od !== undefined ? data[key].od : null;
                const accordance = data[key]?.accordance !== undefined ? data[key].accordance : "N/A";
                if (leftPD !== null || rightPD !== null) {
                    html += `
                        <tr>
                            <td>${key}</td>
                            <td>${leftPD !== null ? leftPD : "N/A"}</td>
                            <td>${rightPD !== null ? rightPD : "N/A"}</td>
                        </tr>
                    `;
                } else {
                    html += `
                        <tr>
                            <td>${key}</td>
                            <td colspan="2">${accordance}</td>
                        </tr>
                    `;
                }
            } else {
                const odValue = data[key]?.od !== undefined ? data[key].od : "N/A";
                const osValue = data[key]?.os !== undefined ? data[key].os : "N/A";
                html += `
                    <tr>
                        <td>${key}</td>
                        <td>${osValue}</td>
                        <td>${odValue}</td>
                    </tr>
                `;
            }
        }
        html += `</tbody></table>`;
        return html;
    }
    // 格式化嵌套对象功能
    function formatNestedObject(obj, indent = 2) {
        let html = '';
        for (const key in obj) {
            const value = obj[key];
            if (typeof value === 'object' && value !== null) {
                const nestedHtml = formatNestedObject(value, indent + 1);
                if (nestedHtml) {
                    if (key == "file") {
                        if (value && value.name) {
                            let fileName = value.name;
                            html += `<div class="nested-data"><strong>${key}:</strong>${fileName}</div>`;
                        }
                    }else{
                        html += `<div class="nested-data" style="display:flex;justify-content: flex-end;"><strong>${key}:</strong>${nestedHtml}</div>`;
                    }
                }
            } else { 
                if (key === 'accordance' && Object.keys(obj).length === 1) {
                    html += `<div class="nested-data"> ${value}</div>`;
                }else{
                    html += `<div class="nested-data"><strong>${key}:</strong> ${value}</div>`;
                }
            }
        }
        return html;
    }
    // 悬停按钮功能
    let hoverBtns = document.querySelectorAll('.hover_btn');
    hoverBtns.forEach(btn => {
        btn.addEventListener('click', function() {
        });
    });
    // 返回按钮功能
    let fromPopUpBtnBack = document.querySelector('.from_pop_up_btn_back');
    fromPopUpBtnBack.setAttribute('disabled', 'disabled');
    fromPopUpBtnBack.addEventListener('click', function () { 
        hoverBtns.forEach(sibling => sibling.classList.remove('active'));
        showNoneAll();
        stepHistory.pop();
        let lastStep = stepHistory[stepHistory.length - 1];
        if (lastStep == "choose_how_to_enter_prescriptions") {
            document.querySelector(".customized-price-number").innerText = document.querySelector("div.price__sale > span.price-item.price-item--sale.price-item--last").innerText.replace('$', '').replace('USD', '').trim()
            document.querySelector(".customized-price-number").setAttribute("data-price", document.querySelector("div.price__sale > span.price-item.price-item--sale.price-item--last").innerText.replace('$', '').replace('USD', '').trim());
            document.querySelectorAll(".progress-bar-box-mb-price-number").forEach(item => {
                item.innerText = document.querySelector("div.price__sale > span.price-item.price-item--sale.price-item--last").innerText.replace('$', '').replace('USD', '').trim()
                item.setAttribute("data-price", document.querySelector("div.price__sale > span.price-item.price-item--sale.price-item--last").innerText.replace('$', '').replace('USD', '').trim());
            });
        }
        if(window.innerWidth >= 749){
            if (document.querySelector('.review_your_selections').classList.contains('display_active_none')) {
                document.querySelector(".customized-wai-product-information-add-to-cart-btn").style.display = 'none';
                document.querySelector(".customized-wai-product-information-price").style.textAlign = 'right';
            } else {  
                document.querySelector(".customized-wai-product-information-add-to-cart-btn").style.display = 'flex';
                document.querySelector(".customized-wai-product-information-price").style.textAlign = 'left';
            }
        }
        if (lastStep == "lens_solution_customization") {
            document.querySelector(".customized-wai-img-box > img").src = firstImgSrc;
        }
        
        document.querySelector('.' + lastStep)?.classList.remove('display_active_none');
        if (configuration.length > 0) {
            configuration.pop();
        }
         
        if (stepHistory.length <= 1) {
            fromPopUpBtnBack.setAttribute('disabled', 'disabled');
            fromPopUpBtnBack.style.opacity = '0.5';
            fromPopUpBtnBack.style.cursor = 'not-allowed';
        }
    });

    // 进度条按钮功能
    let progressBarBoxSvgTui=document.querySelectorAll(".progress-bar-box-svg-tui")
    progressBarBoxSvgTui.forEach(svg => {
        svg.addEventListener('click', function() {
            fromPopUpBtnBack.click();
        });
    });
    initPrescriptionSelectors();
    // 处方数据功能
    let prescriptionData = {
        sphere: { os: 'None', od: 'None' },
        cylinder: { os: 'None', od: 'None' },
        axis: { os: 'None', od: 'None' },
        add: { os: 'None', od: 'None' }
    };
    // 初始化处方选择器功能
    function initPrescriptionSelectors() { 
        const inputs = document.querySelectorAll('.enter_prescription_table_input');
        inputs.forEach(input => {
            const svg = input.querySelector('.enter_prescription_table_input_svg');
            const label = input.querySelector('label');
            const dropdown = input.querySelector('.enter_prescription_table_input_label');
            input.addEventListener('click', (e) => {
                if (e.target.closest('.enter_prescription_table_input_label')) {
                    return;
                }
                document.querySelectorAll('.enter_prescription_table_input').forEach(otherInput => {
                    if (otherInput !== input) {
                        otherInput.querySelector('.enter_prescription_table_input_label')?.style.setProperty('display', 'none');
                        otherInput.querySelector('.enter_prescription_table_input_svg')?.classList.remove('active');
                    }
                });
                if (dropdown) { 
                    const isVisible = dropdown.style.display === 'block';
                    dropdown.style.display = isVisible ? 'none' : 'block'; 
                    svg?.classList.toggle('active');
                }
            });
            const optionsContainer = input.querySelector('.enter_prescription_table_input_all');
            if (optionsContainer) {
                const options = optionsContainer.querySelectorAll('div:not(:has(div))');
                options.forEach(option => {
                    option.addEventListener('click', (e) => {
                        e.stopPropagation();
                        const selectedValue = option.textContent.trim();
                        if (label) {
                            label.textContent = selectedValue;
                            const cell = input.closest('td');
                            const row = input.closest('tr');
                            const cellIndex = Array.from(row.cells).indexOf(cell);
                            const eye = cellIndex === 1 ? 'os' : 'od';
                            const property = row.cells[0].textContent.toLowerCase().split(' ')[0];
                            if (property && prescriptionData[property]) {
                                prescriptionData[property][eye] = selectedValue;
                            }
                            const axisInputs = document.querySelectorAll(".enter_prescription_table_input_axis");

                            if (document.querySelectorAll(".enter_prescription_table_input label")[2].textContent != "Cylinder-os" && document.querySelectorAll(".enter_prescription_table_input label")[2].textContent != "0.00") {
                                axisInputs[0].disabled = false;
                                axisInputs[0].style.opacity = '1';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[0].style.pointerEvents = 'auto';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[0].style.cursor = 'pointer';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[0].style.opacity = '1';
                            }
                            else{
                                axisInputs[0].disabled = true;
                                axisInputs[0].style.opacity = '0.5';
                                axisInputs[0].value = 'None';
                                prescriptionData.axis.os = 'None';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[0].style.pointerEvents = 'none';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[0].style.cursor = 'not-allowed';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[0].style.opacity = '0.5';
                            }

                            if(document.querySelectorAll(".enter_prescription_table_input label")[3].textContent != 'Cylinder-od' && document.querySelectorAll(".enter_prescription_table_input label")[3].textContent != '0.00'){
                                axisInputs[1].disabled = false;  
                                axisInputs[1].style.opacity = '1';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[1].style.pointerEvents = 'auto';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[1].style.cursor = 'pointer';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[1].style.opacity = '1';
                            }
                            else{
                                axisInputs[1].disabled = true;
                                axisInputs[1].style.opacity = '0.5';
                                axisInputs[1].value = 'None';
                                prescriptionData.axis.od = 'None';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[1].style.pointerEvents = 'none';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[1].style.cursor = 'not-allowed';
                                document.querySelectorAll(".enter_prescription_table_input_axis_line")[1].style.opacity = '0.5';
                            }
                        }
                        if (dropdown) {
                            dropdown.style.display = 'none';
                            svg?.classList.remove('active');
                        }
                    });
                });
            }
        });
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.enter_prescription_table_input')) {
                document.querySelectorAll('.enter_prescription_table_input_label').forEach(el => {
                    el.style.display = 'none';
                });
                document.querySelectorAll('.enter_prescription_table_input_svg').forEach(svg => {
                    svg.classList.remove('active');
                });
            }
        });
    }
    // 调整值功能
    function adjustValue(label, step) {
        if (!label) return;
        let currentValue = parseFloat(label.textContent) || 0;
        currentValue += step;
        currentValue = Math.round(currentValue * 100) / 100;
        label.textContent = currentValue.toFixed(2);
        updatePrescriptionData(label.closest('.enter_prescription_table_input'), label.textContent);
    } 
    // 更新处方数据功能
    function updatePrescriptionData(input, value) {
        const cell = input.closest('td');
        const row = input.closest('tr');
        const cellIndex = Array.from(row.cells).indexOf(cell);
        const eye = cellIndex === 1 ? 'os' : 'od';
        const property = row.cells[0].textContent.toLowerCase().split(' ')[0];
        
        if (property && prescriptionData[property]) { 
            prescriptionData[property][eye] = value.toString();
        }
    }
    // 更新add值功能
    function updateAddValue(addBtn, value) {
        const cell = addBtn.closest('td');
        const row = addBtn.closest('tr');
        const cellIndex = Array.from(row.cells).indexOf(cell);
        const eye = cellIndex === 1 ? 'os' : 'od';
        if (!prescriptionData.add) {
            prescriptionData.add = { os: 'None', od: 'None' };
        }
        prescriptionData.add[eye] = value;
    }
    let plusBtns = document.querySelectorAll(".enter_prescription_table_input_axis_line_jia");
    let minusBtns = document.querySelectorAll(".enter_prescription_table_input_axis_line_jian");
    let inputs = document.querySelectorAll(".enter_prescription_table_input_axis");
    let inputValues = Array.from(inputs).map(input => input.value.toString());
    let allValuesStr = inputValues.join(',');
    plusBtns.forEach((btn, index) => {
        btn.addEventListener("click", function () {
            let axis = inputs[index];
            axisvalue(axis, 1);
        });
    });
    minusBtns.forEach((btn, index) => {
        btn.addEventListener("click", function () {
            let axis = inputs[index];
            axisvalue(axis, -1);
        });
    });
    // 轴值功能
    function axisvalue(input, step) {
        let currentValue = parseInt(input.value) || 0;
        currentValue += step;
        input.value = currentValue;
        updatePrescriptionData(input, currentValue);
    }
    inputs.forEach(input => {
        input.addEventListener('input', () => {
            updatePrescriptionData(input, input.value);
        });
    });
    let addBtns = document.querySelectorAll(".enter_prescription_table_input_add_btn");
    addBtns.forEach((btn, index) => {
        btn.addEventListener("click", function () {
            let labelAdd = btn.querySelector('.enter_prescription_table_input_label_add');
            const isVisible = labelAdd.style.display === 'block';
            labelAdd.style.display = isVisible ? 'none' : 'block';
        });
    });
    let addOptions = document.querySelectorAll(".enter_prescription_table_input_all_add div");
    addOptions.forEach(option => {
        option.addEventListener("click", function () {
            let label = option.closest('.enter_prescription_table_input_add_btn').querySelector('label');
            label.textContent = option.textContent;
            updateAddValue(option.closest('.enter_prescription_table_input_add_btn'), option.textContent);
        });
    });
    const tableOne = document.querySelector(".enter_prescription_table_distance_table_one");
    const tableTwo = document.querySelector(".enter_prescription_table_distance_table_two");
    const toggleCheckbox = document.querySelector("#enter_prescription_table_distance_check_input");
    let prescriptionDataDistance = {
        PD: { 
            accordance: 62
        }
    };
    let prescriptionDataDistanceTwo = {
        PD: {
            os: '',
            od: ''
        }
    };
    let enterPrescription = true
    toggleCheckbox.addEventListener("change", function () {
        if (this.checked) {
            enterPrescription = false;
            tableOne.style.display = "none";
            tableTwo.style.display = "table";
            const dividedValue = (parseFloat(prescriptionDataDistance.PD.accordance) / 2).toFixed(1);
            prescriptionDataDistanceTwo.PD.os = dividedValue;
            prescriptionDataDistanceTwo.PD.od = dividedValue;
            document.querySelectorAll(".enter_prescription_table_distance_table_two_td label").forEach((label, index) => {
                label.textContent = index === 0 ? dividedValue : dividedValue;
            });
        } else {
            enterPrescription = true;
            tableOne.style.display = "table";
            tableTwo.style.display = "none"; 
        }
    });
    const tdOne = document.querySelector('.enter_prescription_table_distance_table_one_td');
    const svgOne = tdOne.querySelector('.enter_prescription_table_distance_table_one_svg');
    const labelOne = tdOne.querySelector('label');
    const dropdownOne = tdOne.querySelector('.enter_prescription_table_distance_table_one_render');
    const dropdownTextOne = document.querySelector(".enter_prescription_table_distance_table_one_box");
    tdOne.addEventListener('click', (e) => {
        e.stopPropagation();
        const isVisible = dropdownOne.style.display === 'block';
        document.querySelectorAll('.enter_prescription_table_distance_table_one_render').forEach(d => d.style.display = 'none');
        dropdownOne.style.display = isVisible ? 'none' : 'block';
        svgOne.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(180deg)';
    });
    const optionsOne = dropdownTextOne.querySelectorAll('div');
    optionsOne.forEach(option => {
        option.addEventListener('click', (e) => {
            e.stopPropagation();
            const selectedValue = option.textContent.trim();
            labelOne.textContent = selectedValue;
            prescriptionDataDistance.PD.accordance = selectedValue;
            if (toggleCheckbox.checked) {
                const dividedValue = (parseFloat(selectedValue) / 2).toFixed(1);
                prescriptionDataDistanceTwo.PD.os = dividedValue;
                prescriptionDataDistanceTwo.PD.od = dividedValue;
                document.querySelectorAll(".enter_prescription_table_distance_table_two_td label").forEach((label, index) => {
                    label.textContent = index === 0 ? dividedValue : dividedValue;
                });
            }
            dropdownOne.style.display = 'none';
            svgOne.style.transform = 'rotate(0deg)';
        });
    });
    const tdTwoList = document.querySelectorAll('.enter_prescription_table_distance_table_two_td');
    tdTwoList.forEach((td, index) => {
        const svg = td.querySelector('.enter_prescription_table_distance_table_two_svg');
        const label = td.querySelector('label');
        const dropdown = td.querySelector('.enter_prescription_table_distance_table_two_render');
        const options = dropdown.querySelectorAll('.enter_prescription_table_distance_table_two_box div');
        td.addEventListener('click', (e) => {
            e.stopPropagation();
            const isVisible = dropdown.style.display === 'block';
            document.querySelectorAll('.enter_prescription_table_distance_table_two_render').forEach(d => d.style.display = 'none');
            dropdown.style.display = isVisible ? 'none' : 'block';
            svg.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(180deg)';
        });
        options.forEach(option => {
            option.addEventListener('click', (e) => {
                e.stopPropagation();
                const selectedValue = option.textContent.trim();
                label.textContent = selectedValue;
                if (index === 0) {
                    prescriptionDataDistanceTwo.PD.os = selectedValue;
                } else {
                    prescriptionDataDistanceTwo.PD.od = selectedValue;
                }
                dropdown.style.display = 'none';
                svg.style.transform = 'rotate(0deg)';
            });
        });
    });
    document.addEventListener('click', () => {
        document.querySelectorAll('.enter_prescription_table_distance_table_one_render, .enter_prescription_table_distance_table_two_render').forEach(d => d.style.display = 'none');
        document.querySelectorAll('.enter_prescription_table_distance_table_one_svg, .enter_prescription_table_distance_table_two_svg').forEach(s => s.style.transform = 'rotate(0deg)');
    });
    tableOne.style.display = "table";
    tableTwo.style.display = "none";
    const tableOneFile = document.querySelector(".upload_file_form_table_distance_table_one");
    const tableTwoFile = document.querySelector(".upload_file_form_table_distance_table_two");
    const toggleCheckboxFile = document.querySelector("#upload_file_form_table_distance_check_input");
    let prescriptionDataDistanceFile = {
        PD: {
            accordance: 63 
        },
        file: ''
    };
    let prescriptionDataDistanceTwoFile = {
        PD: {
            os: '',
            od: ''
        },
        file: ''
    };
    let yourPrescription = true;
    toggleCheckboxFile.addEventListener("change", function () {
        if (this.checked) {
            yourPrescription = false;
            tableOneFile.style.display = "none";
            tableTwoFile.style.display = "table";
            const dividedValueFile = (parseFloat(prescriptionDataDistanceFile.PD.accordance) / 2).toFixed(1);
            prescriptionDataDistanceTwoFile.PD.os = dividedValueFile;
            prescriptionDataDistanceTwoFile.PD.od = dividedValueFile;
            document.querySelectorAll(".upload_file_form_table_distance_table_two_td label").forEach((label, index) => {
                label.textContent = index === 0 ? dividedValueFile : dividedValueFile;
            });
        } else {
            yourPrescription = true;
            tableOneFile.style.display = "table";
            tableTwoFile.style.display = "none";
        }
    });
    const tdOneFile = document.querySelector('.upload_file_form_table_distance_table_one_td');
    const svgOneFile = tdOneFile.querySelector('.upload_file_form_table_distance_table_one_svg');
    const labelOneFile = tdOneFile.querySelector('label');
    const dropdownOneFile = tdOneFile.querySelector('.upload_file_form_table_distance_table_one_render'); 
    const dropdownTextOneFile = document.querySelector(".upload_file_form_table_distance_table_one_box");
    tdOneFile.addEventListener('click', (e) => {
        e.stopPropagation();
        const isVisibleFile = dropdownOneFile.style.display === 'block';
        dropdownOneFile.style.display = isVisibleFile ? 'none' : 'block';
        svgOneFile.style.transform = isVisibleFile ? 'rotate(0deg)' : 'rotate(180deg)';
    });
    const optionsOneFile = dropdownTextOneFile.querySelectorAll('div');
    optionsOneFile.forEach(option => {
        option.addEventListener('click', (e) => {
            e.stopPropagation();
            const selectedValue = option.textContent.trim();
            labelOneFile.textContent = selectedValue;
            prescriptionDataDistanceFile.PD.accordance = selectedValue;
            
            if (toggleCheckbox.checked) {
                const dividedValue = (parseFloat(selectedValue) / 2).toFixed(1);
                prescriptionDataDistanceTwo.PD.os = dividedValue;
                prescriptionDataDistanceTwo.PD.od = dividedValue;
                document.querySelectorAll(".upload_file_form_table_distance_table_two_td label").forEach((label, index) => {
                    label.textContent = index === 0 ? dividedValue : dividedValue;
                });
            }
            dropdownOneFile.style.display = 'none';
            svgOne.style.transform = 'rotate(0deg)';
        });
    });
    const tdTwoListFile = document.querySelectorAll('.upload_file_form_table_distance_table_two_td');
    tdTwoListFile.forEach((td, index) => {
        const svg = td.querySelector('.upload_file_form_table_distance_table_two_svg');
        const label = td.querySelector('label');
        const dropdown = td.querySelector('.upload_file_form_table_distance_table_two_render');
        const options = dropdown.querySelectorAll('.upload_file_form_table_distance_table_two_box div');
        td.addEventListener('click', (e) => {
            e.stopPropagation();
            const isVisible = dropdown.style.display === 'block';
            document.querySelectorAll('.upload_file_form_table_distance_table_two_render').forEach(d => d.style.display = 'none');
            dropdown.style.display = isVisible ? 'none' : 'block';
            svg.style.transform = isVisible ? 'rotate(0deg)' : 'rotate(180deg)';
        });
        options.forEach(option => {
            option.addEventListener('click', (e) => {
                e.stopPropagation();
                const selectedValueFile = option.textContent.trim();
                label.textContent = selectedValueFile;
                if (index === 0) {
                    prescriptionDataDistanceTwoFile.PD.os = selectedValueFile;
                } else {
                    prescriptionDataDistanceTwoFile.PD.od = selectedValueFile;
                }
                dropdown.style.display = 'none';
                svg.style.transform = 'rotate(0deg)';
            });
        });
    });
    document.addEventListener('click', () => {
        document.querySelectorAll('.upload_file_form_table_distance_table_one_render, .upload_file_form_table_distance_table_two_render').forEach(d => d.style.display = 'none');
        document.querySelectorAll('.upload_file_form_table_distance_table_one_svg, .upload_file_form_table_distance_table_two_svg').forEach(s => s.style.transform = 'rotate(0deg)');
    });
    tableOneFile.style.display = "table";
    tableTwoFile.style.display = "none";
    const uploadFileFormInput = document.querySelector('.upload_file_form_input'); 
    uploadFileFormInput.addEventListener('change', (e) => {
        const file = e.target.files[0];
        prescriptionDataDistanceFile.file = file;
        prescriptionDataDistanceTwoFile.file = file;
        if(file){
            document.querySelector('.upload_file_link').textContent = file.name;
            document.querySelector('.upload_success_title').textContent = 'Prescription Upload successful';
            document.querySelector('.upload_success_box_img').src = 'https://cdn.shopify.com/s/files/1/0885/7557/4317/files/check.png?v=1749455302';
        }
    });
    let uploadFileLink=document.querySelector('.upload_file_link');
    uploadFileLink.addEventListener('click',function(){
        uploadFileFormInput.click()
    });
    let review_your_selections_btn = document.querySelector('.review_your_selections_btn');
    let review_your_add_to_cart_btn = document.querySelector('.customized-wai-product-information-add-to-cart-btn');
    review_your_add_to_cart_btn.addEventListener('click', function (e) {
        review_your_selections_btn.click();
    }); 
    review_your_selections_btn.addEventListener('click', function (e) {
                let file = document.querySelector("#file").files[0];
                const extractedValues = {};
                configuration.forEach(item => {
                    Object.entries(item).forEach(([key, value]) => {
                        if (typeof value === 'object' && value !== null) {
                            Object.entries(value).forEach(([nestedKey, nestedValue]) => {
                                if (typeof nestedValue === 'object' && nestedValue !== null) {
                                    Object.entries(nestedValue).forEach(([deepNestedKey, deepNestedValue]) => {
                                        const newKey = `${key}-${nestedKey}-${deepNestedKey}`.replace(/\./g, '-');
                                        extractedValues[newKey] = deepNestedValue;
                                    });
                                } else {
                                    const newKey = `${key}-${nestedKey}`.replace(/\./g, '-');
                                    extractedValues[newKey] = nestedValue;
                                }
                            });
                        } else {
                            const newKey = key.replace(/\./g, '-');
                            extractedValues[newKey] = value; 
                        }
                    });
                });
                const formData = new FormData();
                let items = [];
                if (configuration.some(item => item['Prescription need'] === 'Non-Prescription')) {
                    const selectedColorInput = document.querySelector('fieldset.js input[type="radio"]:checked');
                    const selectedColor = selectedColorInput ? selectedColorInput.value : null;
                    if (selectedColor == "Black") {
                        colorProductId = "50761509667117";
                    }else if (selectedColor == "Gradient") {
                        colorProductId = "50761509798189";
                    }else if (selectedColor == "Tortoise") {
                        colorProductId = "50761509929261";
                    }
                    if (colorProductId) {
                        items.push({
                            'id': colorProductId,
                            'quantity': 1,
                            'properties': {}
                        });
                    }
                } else {
                    productIdArr = document.querySelector("input.product-variant-id").value;
                    if (productIdArr) {
                        items.push({
                            'id': productIdArr,
                            'quantity': 1,
                            'properties': {}
                        });
                    }
                }
                Object.entries(extractedValues).forEach(([key, value]) => {
                    if (key === "prescriptionDataFile") {
                        if (value.file) {
                            file = value.file;
                        }
                    } else if (
                        key === "prescriptionData-PD-accordance" || key === "prescriptionDataFile-PD-accordance"
                    ) {
                        const osKey = key.replace('-accordance', '-os');
                        const odKey = key.replace('-accordance', '-od');
                        if (
                            extractedValues[osKey] === undefined && extractedValues[odKey] === undefined
                        ) {
                            const pdKey = key.replace('-accordance', '');
                            let cleanKey = pdKey.replace(/^prescriptionData(File)?-/, '');
                            items[0].properties[cleanKey] = value;
                        }
                    } else if (
                        key === "prescriptionData-PD-os" || key === "prescriptionData-PD-od" ||
                        key === "prescriptionDataFile-PD-os" || key === "prescriptionDataFile-PD-od"
                    ) {
                        let cleanKey = key.replace(/^prescriptionData(File)?-/, '');
                        items[0].properties[cleanKey] = value;
                    } else if (
                        key === "prescriptionData-" || key === "prescriptionDataFile-"
                    ) {
                        return;
                    } else {
                        let cleanKey = key.replace(/^prescriptionData(File)?-/, '');
                        items[0].properties[cleanKey.replace(/ /g, ' ')] = value;
                    }
                });
                if (configuration.some(item => item["Prescription"] === "Upload it now")) {
                    items[0].properties['Your prescription'] = file;
                }
                // 定制区域增加配件的产品ID
                const accessoriesEle = document.getElementById("accessories-product-modal");
                if(accessoriesEle && accessoriesEle.checked) {
                    items.push({
                    'id': accessoriesEle.value,
                    'quantity': 1, 
                    })
                };
                items.forEach((item, index) => {
                    formData.append(`items[${index}][id]`, item.id);
                    formData.append(`items[${index}][quantity]`, item.quantity.toString());
                    if (item.properties) {
                        Object.entries(item.properties).forEach(([key, value]) => {
                            if (
                                (key === 'prescriptiondata-add-od' || key === 'prescriptiondata-add-os') &&
                                value === '--'
                            ) {
                                return;
                            }
                            if (value !== undefined && value !== null) {
                                formData.append(`items[${index}][properties][${key}]`, value);
                            }
                        });
                    }
                });
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData,
                })
                .then(response => {
                    if (!response.ok) {
                        throw new Error('网络响应错误');
                    }
                    return response.json(); 
                }) 
                .then(result => {
                    fetch(window.Shopify.routes.root + 'cart.js', {
                        credentials: 'same-origin',
                        method: 'GET'
                    }).then(response => {
                        window.location.href = '/cart';
                    })
                })
                .catch(error => {
                    console.error('Error:', error);
                });
    });
    let addToCartBtn = document.querySelector('[halli-add-to-cart]');
    addToCartBtn.addEventListener('click', function (e) {
        const selectedColorInput = document.querySelector('fieldset.js input[type="radio"]:checked');
        const selectedColor = selectedColorInput ? selectedColorInput.value : null;
        if (selectedColor == "Black") {
            colorProductId = "50761509667117";
        }else if (selectedColor == "Gradient") {
            colorProductId = "50761509798189";
        }else if (selectedColor == "Tortoise") {
            colorProductId = "50761509929261";
        }

        // Accessories
        let items = [{
            'id': colorProductId,
            'quantity': 1,
            'properties': {
                'Frame Color': selectedColor,
                // 'Ring Size': selectedSize,
                'Prescription need': 'Non-Prescription',
                'Lens type': 'Classic',
            }
        }];
        let response_status = null;

        const accessoriesEle = document.getElementById("accessories-product-page");
        if(accessoriesEle && accessoriesEle.checked) {
            items.push({
               'id': accessoriesEle.value,
               'quantity': 1, 
            })
        };

        const formData = {
            'items': items
        };

        // Loading status
        addToCartBtn.setAttribute('aria-disabled', true);
        addToCartBtn.classList.add('loading');
        addToCartBtn.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => response.json())
        .then(data => {
            if (data.status) {
                response_status = true;
                return;
            };
            if(!response_status) {
                response_status = false;
                window.location.href = '/cart';
            }
        })
        .catch(error => {
            console.error('操作失败:', error);
        })
        .finally(() => {
            addToCartBtn.classList.remove('loading');
            if(!response_status) addToCartBtn.removeAttribute('aria-disabled');
            addToCartBtn.querySelector('.loading__spinner').classList.add('hidden');
        })
    });
    
    function createModal(openBtnSelector, modalContentSelector, modalBoxSelector, closeBtnSelector) {
        const openBtn = document.querySelector(openBtnSelector);
        const modalContent = document.querySelector(modalContentSelector);
        const modalBox = document.querySelector(modalBoxSelector);
        const closeBtn = document.querySelector(closeBtnSelector);
        if (!openBtn || !modalContent || !modalBox || !closeBtn) return;
        function showModal() { 
            if (addForm == "add") {
                document.querySelector(".ring-size-guide-two").innerHTML = `
                                    <div class="sizing-guide">
                                                <img class="hide_mb" style="width: 100%;" src="https://cdn.shopify.com/s/files/1/0885/7557/4317/files/ADD-PC.png?v=1751008354" alt="">
                                                <img class="hide_pc" style="width: 100%;" src="https://cdn.shopify.com/s/files/1/0885/7557/4317/files/ADD-MB.png?v=1751008353" alt="">

                                        </div>
                                        `
            }else if (addForm == "noadd") { 
                document.querySelector(".ring-size-guide-two").innerHTML = `
                                            div class="sizing-guide">
                                                <img class="hide_mb" style="width: 100%;" src="https://cdn.shopify.com/s/files/1/0885/7557/4317/files/009-PC.png?v=1751008251" alt="">
                                                <img class="hide_pc" style="width: 100%;" src="https://cdn.shopify.com/s/files/1/0885/7557/4317/files/009-MB.png?v=1751008250" alt="">

                                        </div>`
            }  
            modalContent.style.display = 'block';
            modalBox.style.transition = 'none';
            modalBox.style.opacity = '0';
            modalBox.style.transform = 'translate(-50%, 70%) scale(0.6)';
            void modalBox.offsetWidth;
            requestAnimationFrame(() => {
                modalContent.classList.add('active');
                modalBox.style.transition = 'transform 0.8s cubic-bezier(0.7, 0, 0.2, 1), opacity 0.8s cubic-bezier(0.7, 0, 0.2, 1)';
                modalBox.style.opacity = '1';
                modalBox.style.transform = 'translate(-50%, -50%) scale(1)';
            });
        }
        function hideModal() {
            modalBox.style.transition = 'transform 0.8s cubic-bezier(0.7, 0, 0.2, 1), opacity 0.8s cubic-bezier(0.7, 0, 0.2, 1)';
            modalBox.style.opacity = '0';
            modalBox.style.transform = 'translate(-50%, 70%) scale(0.6)';
            modalContent.classList.remove('active');
            setTimeout(() => {
                modalContent.style.display = 'none';
                modalBox.style.transition = 'none';
            }, 800);
        }
        openBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            showModal();
        });
        closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            hideModal();
        });
        modalContent.addEventListener('click', (e) => {
            if (e.target === modalContent) {
                hideModal();
            }
        });
    }
    // 创建弹窗功能
    createModal('[ring-content-accessories-product-page]', '.product-tan1', '.product-tan-po', '.product-gb');
    createModal('[ring-content-accessories-product-modal]', '.product-tan1', '.product-tan-po', '.product-gb');
    createModal('[open-klarna-popup]', '.klarna-popup', '.klarna-popup-bg', '.klarna-popup-gb');
    createModal('.ring-content', '.product-tan1', '.product-tan-po', '.product-gb');
    createModal('.interpret_the_prescription_tan2', '.product-tan2', '.product-tan-po2', '.product-gb2');
    createModal('.interpret_the_prescription_tan3', '.product-tan3', '.product-tan-po3', '.product-gb3');
    createModal('.upload_file_form_no_pd4', '.product-tan4', '.product-tan-po4', '.product-gb4');
})()
